import React from 'react';
import clsx from "clsx";
import {makeStyles, Typography} from "@material-ui/core";
import useModal from "Hooks/useModal";
import {BONUS_MONEY_RULES_STRAPLINE} from "Setup/config";
import {BP_MEDIUM} from "Theme/breakpoints";

const useBonusMoneyRulesStraplineStyles = makeStyles(theme => {
    const RulesStraplineSettings = theme.overrides.RulesStrapline;
    return {
        root: {
            backgroundColor: RulesStraplineSettings.background,
            color: "white",
            textAlign: 'center',
            cursor: 'pointer',
        },
        isTransparent: {
            backgroundColor: "transparent"
        },
        small: {
            paddingBottom: "2px",
            lineHeight: 1.2,
            display: "block",
            paddingTop: "2px",
            opacity: 0.8,
            [theme.breakpoints.down(BP_MEDIUM)]: {
                fontSize: '0.6rem',
            },
        },
        typography: {
            fontFamily: ['Helvetica', 'Source Sans Pro', 'sans-serif',].join(','),
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    }
})

const BonusMoneyRulesStrapline = ({children, column = true, textStyle = {}, textClasses = "", ...props}) => {
    const classes = useBonusMoneyRulesStraplineStyles();
    const {launchPromotionalTermsModal} = useModal();

    return (
        <div className={clsx("bg--bonus-money-strapline", classes.root, props.className, {[classes.isTransparent]: props.transparent})}>
            <small className={clsx({["column"]: column}, classes.small)} onClick={launchPromotionalTermsModal}>
                <Typography className={clsx(classes.typography, textClasses)} paragraph={props.paragraph} variant="inherit" style={textStyle}>
                    {children ? children : BONUS_MONEY_RULES_STRAPLINE}
                </Typography>
            </small>
        </div>
    );
}

export default BonusMoneyRulesStrapline;
